import PushNotification from './PushNotification.view';

export default PushNotification;
